import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { RefundsOrderBy, RefundStatus } from '@/interfaces/refund';
import { showErrors, showNotification } from '@/utils/snack';
import { utcDateTimeToLocal } from '@/utils/dateTime';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import AppSimpleTextField from '@/components/AppSimpleTextField.vue';
import AppDialog from '@/components/AppDialog.vue';
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue';
import AppSearchBtn from '@/components/AppSearchBtn.vue';
import AppSimpleSelector from '@/components/AppSimpleSelector.vue';
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue';
import AppSimpleDatePicker from '@/components/AppSimpleDatePicker.vue';
import ListPage from '@/mixins/list-page';
import { RefundStatusText, statusCodes, statusOptions } from '@/helpers/refund';
import { refundKey, refundOptions, RefundWayText } from '@/helpers/order';
import { exportRefundsList, findRefunds } from './gql';
import { findDealers } from '@/views/DealerList/gql';
import { auditStatusText } from '@/helpers/audit';
import { formatCurrency } from '@/utils/currency';
import AppSimpleSearchSelector from '@/components/AppSimpleSearchSelector.vue';
import { SnackType } from '@/interfaces/snack';
import { downloadBase64 } from '@/helpers/base64-to-file';
import { dispatchUpdateIfNewOrders } from '../../store/dispatches';

var RefundList = /*#__PURE__*/function (_mixins) {
  _inherits(RefundList, _mixins);

  var _super = _createSuper(RefundList);

  function RefundList() {
    var _this;

    _classCallCheck(this, RefundList);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '订单管理'
    }, {
      text: '退款单'
    }];
    _this.utcDateTimeToLocal = utcDateTimeToLocal;
    _this.formatCurrency = formatCurrency;
    _this.isGlobal = false;
    _this.options = {
      sortBy: ['createdAt'],
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    };
    _this.filter = {
      refundTransactionNumber: '',
      refundNumber: '',
      refundWay_EQ: null,
      dealerId_OF_order: {
        id: null,
        label: ''
      }
    };
    _this.totalNum = 0;
    _this.refundLoading = true;
    _this.disableConfirm = false;
    _this.detailInfo = null;
    _this.refundDetailDialog = {
      show: false,
      title: '退款单详情',
      disable: false,
      confirmText: '关闭',
      showCancel: false
    };
    _this.headers = [{
      text: '退款方式',
      value: 'refundWay',
      sortable: false,
      width: 140
    }, {
      text: '审核状态',
      value: 'auditStatus',
      sortable: false,
      width: 100
    }, {
      text: '经销商',
      value: 'order.dealer.realname',
      sortable: false,
      width: 80
    }, {
      text: '退款编号',
      value: 'refundNumber',
      sortable: false
    }, {
      text: '微信退款流水号',
      value: 'transactionNumber'
    }, {
      text: '退款状态',
      value: 'status',
      width: 120
    }, {
      text: '申请时间',
      value: 'createdAt',
      width: 160
    }, {
      text: '退款时间',
      value: 'successTime',
      sortable: false,
      width: 160
    }, {
      text: '订单编号',
      value: 'order.orderNumber',
      sortable: false
    }, {
      text: '订单流水号',
      value: 'order.transactionNumber',
      sortable: false
    }, {
      text: '支付用户手机号',
      value: 'order.address.phone',
      sortable: false,
      width: 140
    }, {
      text: '学生姓名',
      value: 'order.address.realname',
      sortable: false,
      width: 120
    }, {
      text: '学校',
      value: 'order.address.school.name',
      sortable: false,
      width: 120
    }, {
      text: '退款金额',
      value: 'totalAmount'
    }, {
      text: '订单金额',
      value: 'totalPrice'
    }];
    _this.refundList = [];
    _this.windowSize = {
      w: 0,
      h: 0
    };
    _this.actionsHeight = 51;
    _this.statusOptions = statusOptions();
    _this.statusCodes = statusCodes();
    _this.RefundStatusText = RefundStatusText;
    _this.refundWayOptions = refundOptions();
    _this.refundKey = refundKey();
    _this.RefundWayText = RefundWayText;
    _this.AuditStatusText = auditStatusText;
    _this.dealerOptions = [];
    return _this;
  }

  _createClass(RefundList, [{
    key: "mounted",
    value: function mounted() {
      this.onResize();
      this.restorePage(this.cache);
      this.getRefundList();
      this.getDealerOptions();
    }
  }, {
    key: "onOptionsChanged",
    value: function onOptionsChanged() {
      this.getRefundList();
    }
  }, {
    key: "usingStatus",
    value: function usingStatus(status) {
      return {
        'u-tag-green': status === RefundStatus.SUCCESS,
        'u-tag-red': status === RefundStatus.CHANGE,
        'u-tag-orange': status === RefundStatus.PROCESSING,
        'u-tag-dark': status === RefundStatus.REFUNDCLOSE,
        'u-tag-blue': status === RefundStatus.TO_BE_REFUND
      };
    }
  }, {
    key: "getDealerOptions",
    value: function () {
      var _getDealerOptions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(query) {
        var where, take, result, typedError;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                where = query && query.model ? {
                  realname: query.model
                } : null;
                take = query && query.take ? query.take : 20;
                _context.prev = 2;
                _context.next = 5;
                return this.$apollo.query({
                  query: findDealers,
                  variables: {
                    order: null,
                    paging: {
                      skip: 0,
                      take: take
                    },
                    where: where
                  }
                });

              case 5:
                result = _context.sent;

                if (result.data.findDealers) {
                  this.dealerOptions = result.data.findDealers.dealers.map(function (option) {
                    return {
                      id: option.id,
                      label: option.realname
                    };
                  });
                }

                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);
                typedError = _context.t0;
                showErrors(typedError.graphQLErrors);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 9]]);
      }));

      function getDealerOptions(_x) {
        return _getDealerOptions.apply(this, arguments);
      }

      return getDealerOptions;
    }()
  }, {
    key: "getRefundList",
    value: function () {
      var _getRefundList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this$options, sortBy, page, itemsPerPage, sortDesc, _this$filter, refundNumber, refundTransactionNumber, refundWay_EQ, dealerId_OF_order, by, asc, order, paging, where, result, typedError;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$options = this.options, sortBy = _this$options.sortBy, page = _this$options.page, itemsPerPage = _this$options.itemsPerPage, sortDesc = _this$options.sortDesc;
                _this$filter = this.filter, refundNumber = _this$filter.refundNumber, refundTransactionNumber = _this$filter.refundTransactionNumber, refundWay_EQ = _this$filter.refundWay_EQ, dealerId_OF_order = _this$filter.dealerId_OF_order;
                by = RefundsOrderBy[sortBy[0] || 'createdAt'];
                asc = !sortDesc[0] || false;
                this.refundLoading = true;
                order = {
                  by: by,
                  asc: asc
                };
                paging = {
                  skip: itemsPerPage * (page - 1),
                  take: itemsPerPage * page
                };
                where = {
                  refundNumber: refundNumber || null,
                  transactionNumber: refundTransactionNumber || null,
                  refundWay_EQ: this.refundKey[refundWay_EQ] || null,
                  dealerId_OF_order: dealerId_OF_order ? dealerId_OF_order.id : null
                };
                _context2.prev = 8;
                _context2.next = 11;
                return this.$apollo.query({
                  query: findRefunds,
                  variables: {
                    order: order,
                    paging: paging,
                    where: where
                  }
                });

              case 11:
                result = _context2.sent;

                if (result) {
                  this.refundList = result.data.findRefunds.refunds;
                  this.totalNum = result.data.findRefunds.paging.totalCount;
                  this.storePage();
                }

                this.refundLoading = false;
                _context2.next = 20;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](8);
                typedError = _context2.t0;
                showErrors(typedError.graphQLErrors);

              case 20:
                dispatchUpdateIfNewOrders({
                  refund: false
                });

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 16]]);
      }));

      function getRefundList() {
        return _getRefundList.apply(this, arguments);
      }

      return getRefundList;
    }()
  }, {
    key: "filterQuerySubmit",
    value: function () {
      var _filterQuerySubmit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getRefundList();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function filterQuerySubmit() {
        return _filterQuerySubmit.apply(this, arguments);
      }

      return filterQuerySubmit;
    }()
  }, {
    key: "detailHandler",
    value: function detailHandler(item) {
      this.detailInfo = item;
      this.refundDetailDialog.show = true;
    }
  }, {
    key: "refundFormCancel",
    value: function refundFormCancel() {
      this.refundDetailDialog.show = false;
    }
  }, {
    key: "refreshList",
    value: function refreshList() {
      this.filter = {};
      this.getRefundList();
    }
  }, {
    key: "exportHandler",
    value: function () {
      var _exportHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this$options2, sortBy, sortDesc, _this$filter2, refundNumber, refundTransactionNumber, refundWay_EQ, dealerId_OF_order, by, asc, order, where, result, _result$data$exportRe, fileName, contentB64, typedError;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                showNotification({
                  msg: '即将开始下载...',
                  type: SnackType.Info
                });
                _this$options2 = this.options, sortBy = _this$options2.sortBy, sortDesc = _this$options2.sortDesc;
                _this$filter2 = this.filter, refundNumber = _this$filter2.refundNumber, refundTransactionNumber = _this$filter2.refundTransactionNumber, refundWay_EQ = _this$filter2.refundWay_EQ, dealerId_OF_order = _this$filter2.dealerId_OF_order;
                by = RefundsOrderBy[sortBy[0] || 'createdAt'];
                asc = !sortDesc[0] || false;
                this.refundLoading = true;
                order = {
                  by: by,
                  asc: asc
                };
                where = {
                  refundNumber: refundNumber || null,
                  transactionNumber: refundTransactionNumber || null,
                  refundWay_EQ: this.refundKey[refundWay_EQ] || null,
                  dealerId_OF_order: dealerId_OF_order ? dealerId_OF_order.id : null
                };
                _context4.prev = 8;
                _context4.next = 11;
                return this.$apollo.query({
                  query: exportRefundsList,
                  variables: {
                    order: order,
                    where: where
                  }
                });

              case 11:
                result = _context4.sent;

                if (result.data) {
                  _result$data$exportRe = result.data.exportRefundsList, fileName = _result$data$exportRe.fileName, contentB64 = _result$data$exportRe.contentB64;
                  downloadBase64(contentB64, fileName);
                }

                this.refundLoading = false;
                _context4.next = 20;
                break;

              case 16:
                _context4.prev = 16;
                _context4.t0 = _context4["catch"](8);
                typedError = _context4.t0;
                showErrors(typedError.graphQLErrors);

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[8, 16]]);
      }));

      function exportHandler() {
        return _exportHandler.apply(this, arguments);
      }

      return exportHandler;
    }()
  }, {
    key: "onResize",
    value: function onResize() {
      this.windowSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
      var actionDom = this.$refs.actions;
      this.actionsHeight = actionDom.clientHeight;
    }
  }]);

  return RefundList;
}(mixins(ListPage));

__decorate([State(function (state) {
  return state.page.RefundList;
})], RefundList.prototype, "cache", void 0);

__decorate([Watch('options', {
  deep: true
})], RefundList.prototype, "onOptionsChanged", null);

RefundList = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppRefreshAndExport: AppRefreshAndExport,
    AppDialog: AppDialog,
    AppSimpleSelector: AppSimpleSelector,
    AppSimpleTextField: AppSimpleTextField,
    AppSearchBtn: AppSearchBtn,
    AppSimpleDistrictSelector: AppSimpleDistrictSelector,
    AppSimpleDatePicker: AppSimpleDatePicker,
    AppSimpleSearchSelector: AppSimpleSearchSelector
  }
})], RefundList);
export default RefundList;